import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";

export default function NotFound() {
  const { lang, t } = useI18n();
  return (
    <div className="bg-white">
      <div className="mx-auto max-w-2xl px-6 lg:px-10 py-24 text-center">
        <h1
          className="text-5xl text-slate-900 tracking-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {t("notFound.title")}
        </h1>
        <p className="mt-4 text-slate-600">{t("notFound.text")}</p>
        <Button
          asChild
          data-testid="notfound-back"
          className="mt-8 rounded-sm bg-slate-900 hover:bg-slate-800 text-white"
        >
          <Link to={`/${lang}`}>{t("thankYou.back")}</Link>
        </Button>
      </div>
    </div>
  );
}
